"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleTracker = void 0;

var _dateformat = _interopRequireDefault(require("dateformat"));

var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));

var _queryString = _interopRequireDefault(require("query-string"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var handleTracker = function handleTracker(data) {
  var userData = data.userData,
      clientWindow = data.window,
      document = data.document,
      event = data.event,
      sessionId = data.sessionId,
      clientId = data.clientId,
      geolocation = data.geolocation,
      player = data.player,
      videoData = data.videoData,
      currentLocation = data.currentLocation,
      linkRedirectUrl = data.linkRedirectUrl,
      _data$project_id = data.project_id,
      project_id = _data$project_id === void 0 ? 'molatv' : _data$project_id,
      _data$client = data.client,
      client = _data$client === void 0 ? 'mola-web' : _data$client,
      utm_source = data.utm_source,
      utm_medium = data.utm_medium,
      utm_campaign = data.utm_campaign;
  var videoId, contentType;

  if (videoData) {
    videoId = videoData.id;

    if (event === 'event_video_plays') {
      contentType = videoData.contentType;
    }
  }

  var clientIp = userData.clientIp,
      userId = userData.uid;
  /* Video Data */

  /* Parse Url Params*/
  // const urlParams = queryString.parse(clientWindow.location.search)

  var urlParams = {};

  if (clientWindow.location.href.includes('u0026')) {
    decodedUrl = clientWindow.location.href.replace(/u0026/g, '&');
    var parts = decodedUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      urlParams[key] = value;
    });
  } else {
    urlParams = _queryString["default"].parse(clientWindow.location.search);
  }
  /* Get & Parse UA */


  var UA = new _uaParserJs["default"]();
  UA.setUA(navigator.userAgent);
  /* Try get user_id & subs
  const userId = _get(users, 'profile.user_id', null);
  let adjustedSubs = [];
  if (userId !== null) {
    adjustedSubs = users.subscriptions.map(
      subs => `${_get(subs, 'subscriptionId', null)}`,
    );
  } else {
    adjustedSubs = [null];
  }
  */

  /* Try get platform and browser */

  var osName = (0, _get2["default"])(UA.getOS(), 'name', null);
  var osVersion = (0, _get2["default"])(UA.getOS(), 'version', null);
  var os = osName !== null && osVersion !== null ? "".concat(osName, " ").concat(osVersion) : null;
  var vendor = (0, _get2["default"])(UA.getDevice(), 'vendor', null);
  var device = vendor !== null ? "".concat(vendor) : null;
  var platform = (0, _get2["default"])(UA.getDevice(), 'type', null);
  var browserName = (0, _get2["default"])(UA.getBrowser(), 'name', null);
  var browserVersion = (0, _get2["default"])(UA.getBrowser(), 'version', null);
  var browser = browserName && browserVersion ? "".concat(browserName, " ").concat(browserVersion) : null;
  /* Get GeoLocation */

  var latitude = geolocation && geolocation.length > 0 && geolocation && geolocation.split(',').length == 2 ? geolocation.split(',')[0] : '';
  var longitude = geolocation && geolocation.length > 0 && geolocation && geolocation.split(',').length == 2 ? geolocation.split(',')[1] : '';
  /* Get referrer */

  var decodedUrl;
  var linkReferrer;

  if (currentLocation) {
    linkReferrer = "".concat(currentLocation.pathname).concat(currentLocation.search);

    if (linkReferrer.includes('u0026')) {
      linkReferrer = decodedUrl.replace(/^.*\/\/[^\/]+/, '');
    }
  }
  /* eslint-disable */


  var payload = {
    data: {
      referrer: linkReferrer,
      host: "".concat(clientWindow.location.host),
      client: client
      /* mola-web, como-web, sstv-web */
      ,
      app: browser,
      session_id: sessionId,
      // Try get+set session_id
      client_id: clientId,
      screen_resolution: "".concat(clientWindow.screen.width, "x").concat(clientWindow.screen.height),
      user_id: userId,
      video_id: videoId,
      // pageContent: document.title || null,
      platform: platform,
      os: os,
      device: device,
      project_id: project_id
      /** molatv, comotv, sstv */
      ,
      ip: clientIp || null,
      //   path: `${clientWindow.location.host}${location.pathname}${location.search}`,
      // action,
      // current_duration: currentDuration,
      // total_duration: totalDuration,
      // currentSubscriptionId: adjustedSubs,
      hit_timestamp: (0, _dateformat["default"])(new Date(), 'yyyy-mm-dd HH:MM:ss', true),
      utm_source: utm_source ? utm_source : urlParams.utm_source || undefined,
      utm_medium: utm_medium ? utm_medium : urlParams.utm_medium || undefined,
      utm_campaign: utm_campaign ? utm_campaign : urlParams.utm_campaign || undefined,
      latitude: latitude,
      longitude: longitude
    },
    table: event
  };

  if (userId) {
    payload.data.user_id = userId;
  }

  if (event === 'event_video_plays') {
    payload.data.path = "".concat(clientWindow.location.host).concat(location.pathname).concat(location.search);
    payload.data.video_type = contentType || null;

    if (player) {
      payload.data.interval_beats = player.totalWatchTime ? '60' : '0';

      if (player.levels_ && player.levels_.length > 0) {
        for (var i = 0; i < player.levels_.length; i++) {
          // console.log("player.levels_[i]", player.levels_[i])
          if (player.levels_[i].active) {
            payload.data.video_quality = player.levels_[i].height;
            payload.data.bitrate = Math.round((0, _get2["default"])(player.levels_[i], 'bandwidth', 0) / 1000);
            break;
          }
        }
      }

      if (player.bitrate) {
        payload.data.bitrate = player.totalWatchTime ? Math.round(player.bitrate / 1000) : 0;
      } else {
        if (!player.totalWatchTime) payload.data.bitrate = 0;
      }

      payload.data.buffer_duration = player.bufferDuration || '0';
      payload.data.buffer_counter = player.bufferCounter || 0; // if(player.bufferDuration) {
      //   payload.data.buffer_duration = player.bufferDuration;
      // }
      // if(player.bufferCounter) {
      //   payload.data.buffer_counter = player.bufferCounter;
      // }

      if (player.video_quality) {
        payload.data.video_quality = player.video_quality;
      } // payload.data.client_bandwidth =

    }
  } else {
    var linkPath = "".concat(location.pathname).concat(location.search);

    if (linkPath.includes('u0026')) {
      linkPath = decodedUrl.replace(/^.*\/\/[^\/]+/, '');
    }

    payload.data.path = linkRedirectUrl ? linkRedirectUrl : linkPath;
    payload.data.page_content = document.title || null; // payload.data.current_subscription_id = adjustedSubs
  }

  return payload;
};

exports.handleTracker = handleTracker;